import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as Unactive } from "../../assets/dashboardIcons/stepperUnactive.svg"
import { ReactComponent as Active } from "../../assets/dashboardIcons/stepperActive.svg"
import "./stepper.scss"



const CustomStepper = ({ steps, activeStep, setActiveStep }) => {


    const handleStepClick = (index) => {
        setActiveStep(index);
    };

    return (
        <Box className="Stepper">
            {steps.map((step, index) => (
                <Box key={index} onClick={() => handleStepClick(index+1)}>
                    <p
                        style={{
                            color: index+1 === activeStep ? '#57C700' : '#225CA6',
                        }}
                    >
                        {step}
                    </p>
                    <div className='Stepper__step'>
                        {index <= activeStep - 1 ? (
                            <Active />

                        ) : (
                            <Unactive />

                        )}
                    </div>
                </Box>
            ))}
        </Box>
    );
};

export default CustomStepper;

